<template>
  <div class="_modals">
    <b-modal
      id="modal-confirm"
      ref="modalConfirmOption"
      centered
      hide-header
      hide-footer
    >
      <div class="modal-body">
        <div class="d-flex justify-content-center mt-5">
          <svg
            v-if="option === 'yes'"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 0C3.14031 0 0 3.14031 0 7C0 10.8597 3.14031 14 7 14C10.8597 14 14 10.8597 14 7C14 3.14031 10.8597 0 7 0ZM10.0337 5.64415L6.53369 9.68262C6.38615 9.85169 6.17615 9.95292 5.95215 9.96046C5.94246 9.96046 5.93277 9.96046 5.92308 9.96046C5.70877 9.96046 5.50308 9.87538 5.35231 9.72354L3.46769 7.83892C3.15215 7.52338 3.15215 7.01185 3.46769 6.69631C3.78323 6.38077 4.29477 6.38077 4.61031 6.69631L5.88215 7.96708L8.81354 4.58446C9.10538 4.24846 9.61477 4.21077 9.95292 4.50262C10.2889 4.79769 10.3255 5.30708 10.0337 5.64415Z"
              fill="#1D3354"
            />
          </svg>
          <svg
            v-if="option === 'no'"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="7" cy="7" r="7" fill="#C4232A" />
            <path
              d="M7.69078 8.2218H6.63733L6.41714 4.00366H7.91097L7.69078 8.2218ZM6.39987 9.69836C6.39987 9.45658 6.46463 9.27381 6.59416 9.15004C6.72368 9.02628 6.91221 8.96439 7.15974 8.96439C7.39864 8.96439 7.58285 9.02772 7.71237 9.15436C7.84477 9.28101 7.91097 9.46234 7.91097 9.69836C7.91097 9.92574 7.84477 10.1056 7.71237 10.238C7.57997 10.3676 7.39576 10.4323 7.15974 10.4323C6.91796 10.4323 6.73088 10.369 6.59847 10.2424C6.46607 10.1128 6.39987 9.9315 6.39987 9.69836Z"
              fill="white"
            />
          </svg>
        </div>
        <p class="text-center mt-3 font-italic">{{ message }}</p>
      </div>
      <div class="d-flex justify-content-center w-100 mt-3 mb-5">
        <button
          @click="confirmModal"
          class="button__bluecorporite mr-2 ml2 "
          style="border"
        >
          Ok
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'OptionModal',
  data () {
    return {
      option: '',
      message: ''
    }
  },
  created () {
    this.$eventHub.$on('dialog-modal-confirm', this.dialogOption)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-modal-confirm')
  },
  methods: {
    dialogOption ({ option, message }) {
      this.option = option
      this.message = message
      this.$refs.modalConfirmOption.show()
    },

    confirmModal () {
      this.$refs.modalConfirmOption.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/ConfirmModal.vue